//////////////////////////////////////////////////////////////////////////////// FRESH-SHOP
import './eshop'

//////////////////////////////////////////////////////////////////////////////// UI APPLICATION
var uiApp = angular.module("uiApp", ["freshShop", "ngAnimate", "ngVue"]);

///////////////////////////////////////////////////////// COOKIES MESSAGE
import CookiesMsg from './components/cookies-msg/cookies-msg'
uiApp.value('CookiesMsg', CookiesMsg);

import './imports/mobileMenu'
import './eshop'
import './imports/sticky-menu'
import './imports/top-drawer'
import {
    InlineOptions
} from './imports/fancybox-options'

$('.lazy').Lazy({
    enableThrottle: false,
    threshold: 0,
});

$('.lazy-fade').Lazy({
    effect: "fadeIn",
    effectTime: 1500,
    threshold: 0,
    onFinishedAll: function () {
        console.log("lazy loaded");
        
        setTimeout(function () {
            $('.fade-after-lazy').addClass('show')
        }, 1750);
    }
});

$("[data-bg-src]").each(function () {
    var imgUrl = $(this).data("bg-src");
    $(this).css({
        "background-image": "url(" + imgUrl + ")"
    });
})

$('[data-fancybox-inline]').fancybox(InlineOptions);


// WEBPACK FOOTER //
// ./src/js/common.js